import { getAllTasks } from "../controllers/taskController";

export const handleGetAllTasks = async (options = {}) => {
  const { tasks, lastVisible, firstVisible } = await getAllTasks(options);

  return {
    tasks,
    firstDoc: firstVisible?.id,
    lastDoc: lastVisible?.id || null,
  };
};
